import { CategoryPointTooltip, DateSeriesPointTooltip, DollarAndPercentageTooltip, ProjectedGrowthTooltip, ProjectedReturnTooltip, SeriesCategoryPointTooltip, SeriesPointTooltip } from '../models';

/**
 * TooltipDispatcher dispatches the correct tooltip based on the tooltipType.
 * @param {string} tooltipType the tooltip type.
 */
export class TooltipDispatcher {
	public static getTooltipFormatter(tooltipType?: string): Function {
		switch (tooltipType) {
			case 'date-series-point':
				return DateSeriesPointTooltip.getFormatter();
			case 'dollar-and-percentage':
				return DollarAndPercentageTooltip.getFormatter();
			case 'series-category-point':
				return SeriesCategoryPointTooltip.getFormatter();
			case 'category-point':
				return CategoryPointTooltip.getFormatter();
			case 'projected-growth':
				return ProjectedGrowthTooltip.getFormatter();
			case 'projected-return':
				return ProjectedReturnTooltip.getFormatter();
			case 'series-point':
				return SeriesPointTooltip.getFormatter();
			default:
				return SeriesPointTooltip.getFormatter();
		}
	}
}
